var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            width: 190,
            "nudge-bottom": 44,
            bottom: "",
            left: "",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        { attrs: { outlined: "", disabled: _vm.disabled } },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-table"),
                      ]),
                      _vm._v("Visualización"),
                      _c("v-icon", { attrs: { size: "18", right: "" } }, [
                        _vm._v("mdi-chevron-down"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "pa-5" },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center", "no-gutters": "" } },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "grey-700--text subtitle-2 font-weight-semibold",
                        },
                        [_vm._v("Columnas")]
                      ),
                    ]
                  ),
                  _vm._l(_vm.headersList, function (header) {
                    return _c(
                      "v-col",
                      {
                        key: header.value,
                        staticClass: "pa-0 mt-2",
                        attrs: { cols: "12" },
                      },
                      [
                        !["actions"].includes(header.value) && !header.fixed
                          ? _c("v-checkbox", {
                              staticClass: "ma-0 vcheckbox",
                              attrs: {
                                color: "green-500",
                                row: "",
                                label: _vm.label(header),
                                dense: "",
                                "hide-details": "",
                              },
                              model: {
                                value: header.show,
                                callback: function ($$v) {
                                  _vm.$set(header, "show", $$v)
                                },
                                expression: "header.show",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _c("v-divider", { staticClass: "my-5" }),
                  _c(
                    "span",
                    {
                      staticClass:
                        "grey-700--text subtitle-2 font-weight-semibold",
                    },
                    [_vm._v("Registros")]
                  ),
                  _vm._l(_vm.recordList, function (record) {
                    return _c(
                      "v-col",
                      {
                        key: record,
                        staticClass: "pa-0 mt-2",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "v-radio-group",
                          {
                            staticClass: "ma-0",
                            attrs: {
                              row: "",
                              absolute: "",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.pageSize,
                              callback: function ($$v) {
                                _vm.pageSize = $$v
                              },
                              expression: "pageSize",
                            },
                          },
                          [
                            _c("v-radio", {
                              attrs: {
                                label: record.toString(),
                                color: "green-500",
                                value: record,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c("v-divider", { staticClass: "my-5" }),
                  _c(
                    "v-col",
                    { staticClass: "text-center pa-0" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "grey-900",
                            block: "",
                            ripple: false,
                          },
                          on: { click: _vm.save },
                        },
                        [_vm._v("Aplicar")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }